exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "phone-msg .phone-bg{padding:0 30px 150px 0;background-color:#fff;position:relative}phone-msg .fromThem{background:#e5e5ea;color:#000;float:left;clear:both;border-bottom-left-radius:30px 0px\\9;position:relative;padding:5px 20px;border-radius:15px;width:200px;min-height:50px;font-size:15px}phone-msg .fromThem p{white-space:pre-line}phone-msg .fromThem:before{content:\"\";position:absolute;z-index:2;bottom:-2px;left:-7px;height:19px;border-left:20px solid #e5e5ea;border-bottom-right-radius:16px 14px;transform:translateY(-2px);border-bottom-right-radius:15px 0px\\9;transform:translate(-1px,-2px)\\9}phone-msg .fromThem:after{content:\"\";position:absolute;z-index:3;bottom:-2px;left:19px;width:11px;height:20px;background:#fff;border-bottom-right-radius:10px;transform:translate(-30px,-2px)}phone-msg .link{word-break:break-all;color:blue;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/common/phone-msg/phone-msg.scss
// module id = 734
// module chunks = 0